import Text from 'shared/components/Text/Text';
import styled from 'styled-components';
import { AccountBodyContainer } from '../AccountBody/AccountBody.styles';

export const ContentBody = styled(AccountBodyContainer)`
  margin-top: 22px;
  padding: 0px 16px;
  overflow: auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    padding: 0px 24px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin-top: 44px;
    padding: 0px 40px;
  }
`;

export const ContactInfoBodyHeader = styled.div`
  margin-bottom: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin-bottom: 32px;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin-bottom: 42px;
  }
`;

export const TitleIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ValueButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 24px;

  button {
    align-self: flex-end;
  }
`;

export const ItemTitle = styled(Text)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondarySubtleGrey80};
`;

export const Value = styled(Text)<{ $colorBlue: boolean }>`
  font-weight: 700;
  color: ${({ $colorBlue, theme }) =>
    $colorBlue ? theme.colors.textPrimarySecondary1100 : theme.colors.textSecondarySubtleGrey80};
`;
